export const buildPayload = (
  selectedKeys: string[],
  fileNameMap: Record<string, string | null>
): Array<Record<string, string>> => {
  const allKeys = [
    'imageOneChecked',
    'imageTwoChecked',
    'imageThreeChecked',
    'imageFourChecked',
    'imageFiveChecked',
  ]

  const keyToIndex: Record<string, string> = {
    imageOneChecked: '1',
    imageTwoChecked: '2',
    imageThreeChecked: '3',
    imageFourChecked: '4',
    imageFiveChecked: '5',
  }

  const payload: Array<Record<string, string>> = []

  for (const key of allKeys) {
    const index = keyToIndex[key]
    const fileName = fileNameMap[key]
    const isSelected = selectedKeys?.includes(key)

    // Only include entries when there is a filename available or the key was explicitly selected
    if (!fileName && !isSelected) continue

    const entry: Record<string, string> = {}
    entry[`imageAi${index}`] = fileName || ''
    entry.valueString = isSelected ? 'true' : 'false'

    payload.push(entry)
  }

  return payload
}

export const getLocalTimeFromEpoch = (epochTime: number): string => {
  try {
    const date = new Date(epochTime)
    return date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    })
  } catch (error) {
    return '-'
  }
}
